import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  setPasswordResendTimestamp,
  getPasswordResendTimestamp,
  canResetPasswordResendTimestamp,
  getFormattedTimeLeftUntilPasswordResendIsPossible
} from 'src/logic/utils';
import * as actions from '../../RegistrationPopup/redux/registrationPopupActions';
import moment from 'moment';

class EditPhoneInputTimer extends Component {
  constructor(props) {
    super(props);
    this.submitPhone = this.submitPhone.bind(this);
  }
  componentDidMount() {
    if (!canResetPasswordResendTimestamp()) {
      this.updateIntervalToken = setInterval(this.update, 1000);
    }
  }

  submitPhone() {
    this.props.requestChangePhonePass(this.props.newPhone)
      .then((res) => {
        if(res.error)
          alert(res.error);
        else {
          this.props.setNewPhone(value);
        }
      });
  }


  update = () => this.forceUpdate();

  componentWillUnmount() {
    clearInterval(this.updateIntervalToken);
  }

  render() {
    let content;
    if (canResetPasswordResendTimestamp()) {
      content = (
        <button className="link" onClick={this.submitPhone}>выслать код</button>
      );
    } else {
      content = getFormattedTimeLeftUntilPasswordResendIsPossible();
    }
    return (
      <div>{content}</div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.registrationPopupReducer,
    newPhone: state.userReducer.NewPhone
  }),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(EditPhoneInputTimer);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/EditPhoneInputTimer.jsx
 **/